module.exports = __webpack_public_path__ + "img/tl.de4451e3.png";